import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { Zap } from 'lucide-react';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginAdmin(email, password);
      toast.success('Welcome back!');
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md border-2" data-testid="admin-login-card">
        <CardHeader className="text-center space-y-4 pb-2">
          <img src="/logo.png" alt="Wayfinder Guides" className="mx-auto w-16 h-16 rounded-2xl" />
          <CardTitle className="text-3xl font-bold tracking-tight">Wayfinder Admin</CardTitle>
          <p className="text-muted-foreground text-sm">Sign in to manage your audio guides</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input data-testid="login-email-input" id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@sparky.com" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input data-testid="login-password-input" id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" />
            </div>
            <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full bg-[#1A9DA5] hover:bg-[#158D92] text-white">
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
